import React from 'react';
import { Card, Row, Col, Typography, Space, Select } from 'antd';
import { UserOutlined, ClockCircleOutlined, HomeOutlined, TeamOutlined, SmileOutlined, SolutionOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { Option } = Select;

// Mock Data (replace with real data as needed)
const stats = [
    { title: 'Total Employees', value: 127, icon: <UserOutlined style={{ fontSize: 24 }} />, color: '#fa8c16' },
    { title: 'Ontime Arrivals', value: 112, icon: <ClockCircleOutlined style={{ fontSize: 24 }} />, color: '#1890ff' },
    { title: 'Late Arrivals', value: 10, icon: <SolutionOutlined style={{ fontSize: 24 }} />, color: '#52c41a' },
    { title: 'Not In Yet', value: 0, icon: <HomeOutlined style={{ fontSize: 24 }} />, color: '#722ed1' },
    { title: 'Vacation/Week-Off', value: 0, icon: <SmileOutlined style={{ fontSize: 24 }} />, color: '#fadb14' },
    { title: 'Remote Clock-In', value: 5, icon: <TeamOutlined style={{ fontSize: 24 }} />, color: '#13c2c2' },
];

const AttendanceStats: React.FC = () => {
    return (
        <Row gutter={[16, 16]} justify="space-between">
            {stats.map((stat, index) => (
                <Col xs={24} sm={12} md={8} lg={4} key={index}>
                    <Card bordered={false} style={{ textAlign: 'center', border: '1px solid #f0f0f0' }}>
                        <Space direction="vertical" size="small" align="center">
                            <div style={{ color: stat.color }}>{stat.icon}</div>
                            <Text strong>{stat.title}</Text>
                            <Title level={3}>{stat.value}</Title>
                            <Text type="secondary" style={{ color: '#722ed1' }}>
                                View Employees
                            </Text>
                        </Space>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default AttendanceStats;
